<template>
	<div class="basic-container popup">
		<div class="popup-complain-area">
			<article v-for="row in complaintList" v-bind:key="row.regDate">
				<nav-link class="list-head" :click="() => isOpen(row.seqNo)">
					<div class="col-label">
						<label class="red" v-if="row.complaintType === 'REFUND'">환불요청</label>
						<label class="yellow" v-if="row.complaintType === 'OUTCOME'">성과물 미흡</label>
						<label class="yellow" v-if="row.complaintType === 'EXPERTISE'">전문성 부족</label>
						<label class="red" v-if="row.complaintType === 'CONTACT'">연락 미흡</label>
						<label class="yellow" v-if="row.complaintType === 'ETC'">기타</label>
					</div>
					<v-clamp class="col-title" autoresize :max-lines="1"> {{ row.contentTitle }}</v-clamp>
					<span class="col-date">{{ $moment(row.regDate).format('YY-MM-DD') }}</span>
					<div class="col-button" :id="row.seqNo">
						<font-awesome-icon icon="chevron-down" v-if="row.seqNo === complaintSeqNo" />
						<font-awesome-icon icon="chevron-up" v-else />
					</div>
				</nav-link>
				<div class="list-body" v-if="row.seqNo === complaintSeqNo">
					<v-clamp class="title" autoresize :max-lines="1">
						{{ row.contentTitle }}
					</v-clamp>
					<div class="contents">
						{{ row.contentBody }}
					</div>
					<div class="comments-area">
						<div class="comments-head" v-for="commentRow in complaintCommentList" v-bind:key="commentRow.regDate">
							<div class="btn-menu" v-if="loginMember.seqNo === commentRow.userSeqNo">
								<a v-on:click="updateSeqNo = ''" v-if="commentRow.seqNo === updateSeqNo">취소</a>
								<a @click="showUpdateComment(commentRow.seqNo, commentRow.rContext)" v-else>수정</a> |
								<a @click="delComment(commentRow.seqNo)">삭제</a>
							</div>
							<p class="comments-name">{{ commentRow.rName }}</p>
							<p class="comments-date">
								{{
									commentRow.modDate !== null
										? $moment(commentRow.modDate).format('YY-MM-DD hh:mm')
										: $moment(commentRow.regDate).format('YY-MM-DD hh:mm')
								}}
							</p>
							<div class="comments-body" v-if="commentRow.seqNo === updateSeqNo">
								<textarea class="height-5" v-model="commentRow.rContext"></textarea>
								<button class="pinkBtn tiny" @click="updateComment(commentRow.seqNo, commentRow.rContext)">수정</button>
							</div>
							<p class="comments-text" v-else>
								{{ commentRow.rContext }}
							</p>
						</div>
						<div class="comments-body">
							<textarea class="height-5" placeholder="텍스트를 입력해주세요." v-model="commentBody"></textarea>
							<button class="pinkBtn tiny" @click.once="doSubmitComment()">등록</button>
						</div>
					</div>
				</div>
			</article>
		</div>
	</div>
</template>

<script>
import CONST from '@/constants';

export default {
	title: '민원',
	name: 'PopupComplain',
	props: ['matchSeqNo'],
	watch: {
		complaintSeqNo: function(v) {
			this.commentBody = '';
			if (v) this.getComplaintCommentList();
		},
	},
	data: function() {
		return {
			loginMember: null,
			complaintSeqNo: '',
			complaintList: null,
			complaintCommentList: null,
			commentBody: '',
			rContext: '',
			updateSeqNo: '',
		};
	},
	created() {},
	mounted() {
		this.$device.sendEvent(CONST.EVENTS.SET_SIDE_MENU, 'BIZ');
		this.getComplaintList();
		let data = this.$device.loadLocalData('LOGIN_USER');
		if (data) this.loginMember = JSON.parse(data);
	},
	computed: {
		isCompany: function() {
			return this.loginMember && this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY;
		},
	},
	methods: {
		isOpen: function(e) {
			if (this.complaintSeqNo === e) this.complaintSeqNo = 0;
			else this.complaintSeqNo = e;
		},
		getComplaintList: function() {
			let formData = new FormData();
			formData.append('matchSeqNo', this.matchSeqNo);
			formData.append('orderType', 'regDate');
			formData.append('listOrder', 'desc');
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/business/getComplaintList.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.complaintList = res.data.data;
						if (this.complaintList && this.complaintList.length > 0) {
							this.isOpen(this.complaintList[0].seqNo);
						}
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		getComplaintCommentList: function() {
			let formData = new FormData();
			formData.append('complaintSeqNo', this.complaintSeqNo);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/business/getComplaintCommentList.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.complaintCommentList = res.data.data;
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		showUpdateComment: function(commentSeqNo, rContext) {
			this.updateSeqNo = commentSeqNo;
			this.rContext = rContext;
		},
		updateComment: function(commentSeqNo, rContext) {
			let formData = new FormData();
			formData.append('commentSeqNo', commentSeqNo);
			formData.append('rContext', rContext);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/business/updateComplaintsComment.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.updateSeqNo = '';
						this.getComplaintCommentList();
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
		delComment: function(commentSeqNo) {
			var result = confirm('삭제하시겠습니까?');
			if (result) {
				let formData = new FormData();
				formData.append('commentSeqNo', commentSeqNo);
				this.$apiClient
					.getInstance()
					.post(this.$apiClient.getApiServer() + '/api/business/deleteComplaintsComment.do', formData)
					.then(res => {
						if (res.data.resultCode === 0) {
							this.getComplaintCommentList();
						} else {
							window.alert(res.data.resultMsg);
						}
					})
					.catch(e => console.error(e));
			}
		},
		doSubmitComment: function() {
			if (this.commentBody.trim() === '') {
				alert('댓글 내용을 입력하세요.');
				return false;
			}
			let rName = this.isCompany ? this.loginMember.companyNmKor : this.loginMember.userNmKor;
			let formData = new FormData();
			formData.append('complaintSeqNo', this.complaintSeqNo);
			formData.append('userSeqNo', this.loginMember.seqNo);
			formData.append('rName', rName);
			formData.append('rContext', this.commentBody);
			this.$apiClient
				.getInstance()
				.post(this.$apiClient.getApiServer() + '/api/business/insertComplaintsComment.do', formData)
				.then(res => {
					if (res.data.resultCode === 0) {
						this.commentBody = '';
						this.getComplaintCommentList();
					} else {
						window.alert(res.data.resultMsg);
					}
				})
				.catch(e => console.error(e));
		},
	},
};
</script>

<style scoped></style>
